import { DynamicEntry } from 'controls/designer/features/widgets/textWidget/types';
import { newGuid } from 'tools/guid';

// A pasted dsv span keeps the data-id of the entry it was copied from, so without this the
// paste would make the new span share (and corrupt, since it's looked up by that id) the
// original entry instead of getting its own copy.
export function regeneratePastedDynamicEntryIds(node: HTMLElement, entries: DynamicEntry[]) {
	const spans = node.querySelectorAll<HTMLElement>('[data-id]');
	spans.forEach((span) => {
		const oldId = span.getAttribute('data-id');
		const entry = entries.find((e) => e.id === oldId);
		if (!entry) return;

		const clone = { ...(JSON.parse(JSON.stringify(entry)) as DynamicEntry), id: newGuid() };
		entries.push(clone);
		span.setAttribute('data-id', clone.id);
	});
}
